import React from 'react'
import Header from '../../components/header/header.component'
import styles from '../../index.module.css'

export default function LastSearches(){
    return <div className={styles.main}>
    <Header />
    <h1>Last Searches</h1>
    </div>
}